'use client';

import BlogArticleRails from './BlogArticleRails';
import BlogViewCounter from './BlogViewCounter';

export default function BlogArticleClient({ slug, postCards, destinationCards }) {
  return (
    <>
      <BlogViewCounter slug={slug} />
      <BlogArticleRails postCards={postCards} destinationCards={destinationCards} />
    </>
  );
}
